/**
 * 课程学习记录
 */

export const CourseRecordList=[
    {
        prop:"userName",
        label:"用户名称",
        width:"150",
        isShow:true
    },
    {
        prop:"nickName",
        label:"用户昵称",
        width:"150",
        isShow:true
    },
    {
        prop:"unitName",
        label:"企业名称",
        width:"200",
        isShow:true
    },
    {
        prop:"phone",
        label:"手机号",
        width:"150",
        isShow:true
    },
    {
        prop:"title",
        label:"课程名称",
        width:"200",
        isShow:true
    },
    {
        prop:"totalMinsClassHour",
        label:"课程总时长(课时)",
        width:"150",
        isShow:true
    },
    {
        prop:"watchClassHour",
        label:"学习时长(课时)",
        width:"150",
        isShow:true
    },
    {
        prop:"progress",
        label:"学习进度",
        width:"150",
        isShow:true
    }
 ]

